import React from 'react';
import {
  ProcessSection,
  SectionHeading,
  ProcessGrid,
  ProcessItem,
  ProcessNumber,
} from './Process.styles';

const Process = () => {
  return (
    <ProcessSection>
      <SectionHeading $center>
        <p className="eyebrowHeader">How It Works</p>

        <h2>From Your Workplace to a Finished Safety Manual</h2>

        <p>
          We work with your organization to understand what you need and turn
          that information into a practical workplace resource.
        </p>
      </SectionHeading>

      <ProcessGrid>
        <ProcessItem>
          <ProcessNumber>01</ProcessNumber>

          <h3>Talk With Our Team</h3>

          <p>
            Tell us about your workplace, operations, and the type of safety
            documentation your organization needs.
          </p>
        </ProcessItem>

        <ProcessItem>
          <ProcessNumber>02</ProcessNumber>

          <h3>Develop the Manual</h3>

          <p>
            We build the documentation around the needs and structure of your
            organization.
          </p>
        </ProcessItem>

        <ProcessItem>
          <ProcessNumber>03</ProcessNumber>

          <h3>Review the Content</h3>

          <p>
            Your organization can review the manual and confirm the information
            reflects your workplace.
          </p>
        </ProcessItem>

        <ProcessItem>
          <ProcessNumber>04</ProcessNumber>

          <h3>Make It Accessible</h3>

          <p>
            The finished manual can also be made available digitally through
            your company account.
          </p>
        </ProcessItem>
      </ProcessGrid>
    </ProcessSection>
  );
};

export default Process;
